import React, {useEffect, useState} from 'react';
import './styles.css';
import FiltersContentLoader from '../../../../components/FiltersContentLoader';
import ENDPOINT from '../../../../constants/endpoints';
import useApi from '../../../../hooks/useApi';

const EmailHistory = ({candidateId}) => {
  const api = useApi();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    api.getRequest(ENDPOINT.COLLECTION.CANDIDATE_PROFILE_EMAIL_HISTORY, {candidateId: candidateId}, {
      handleSuccess: setData,
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <FiltersContentLoader />;
  }

  return (
    <div className="sidebar__widget">
      <div className="sidebar__block">
        <h3 className="sidebar__title">Emails History</h3>
      </div>
      <div className="sidebar__block" style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
        {data.length === 0 && <div>No emails found</div>}
        {data.map((item, index) => (
          <div key={index} className="emails-history__item">
            <div className="emails-history__item-title">{item.sender_name}</div>
            <div className="emails-history__item-description">{item.subject}</div>
            <div className="emails-history__item-date">{item.timestamp}</div>
          </div>
        ))}
      </div>
    </div>
  )
};

export default EmailHistory;
